module.exports = __webpack_public_path__ + "static/img/about2.35bb30f1.jpg";